module.exports = __webpack_public_path__ + "static/img/bg_coupon_one_grey_used.b86bb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_one_grey_used.png
// module id = LS7L
// module chunks = 0